import React, { Component } from "react";
import { withRouter } from "react-router";
import { Toast } from "../../utils/sweetalert";

import {
  Row,
  Col,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  ButtonGroup,
  Form,
  Label
} from "reactstrap";
import api from "../../utils/axiosApi";
import withReactContent from "sweetalert2-react-content";


class FormAddActToCity extends Component {
  constructor(props) {
    super(props) 
    const {id} = props.match.params
    const calendarData = props.location.state
    debugger
    if(id === calendarData._id) {
        this.state = {
            city : id || '',
            country : '',
            actualcountry : '',
            distance:1,
            activiteCountryList:[],
            actividades: [],
            pages: {    
                actualPage: 0,
                maxPages: 0,
            },
            errors : {
                city : false,
                state : false,
                country : false,
                citiesList:false
            }
          }

    }
    this.handleSearch = this.handleSearch.bind(this)
    this.nextPage = this.nextPage.bind(this)
    this.PrevPage = this.PrevPage.bind(this)
    this.handleToggle = this.handleToggle.bind(this)
  }

  async componentDidMount() {
    if(this.state.city === '') {
        this.props.history.goBack()
    }
    
    const respAct = await api.get(`/adminsplaces/getfromcountry?country=`)
    
    const resp = await api.get(`/adminsplaces/get/${this.state.city}`)
    debugger
    this.setState({
        activiteCountryList: resp.data.data.map((a) => a._id),
        actividades: respAct.data.data,
        pages:{actualPage: 0, maxPages:respAct.data.items}
    })
  }
  nextPage = async () => {
      const {pages, actualcountry} = this.state
    if(pages.actualPage+1 === pages.maxPages) {return}
    const nextPage = pages.actualPage +1
    const resp = await api.get(`/adminsplaces/getfromcountry?country=${actualcountry}`)
    this.setState({
        pages: {...this.state.pages, actualPage:nextPage},
        actividades: resp.data.data
    })
    
  }
  
  PrevPage = async () => {
    
    const {pages, actualcountry} = this.state
    if(pages.actualPage === 0) {return}
    const nextPage = pages.actualPage -1
    
    const resp = await api.get(`/adminsplaces/getfromcountry?country=${actualcountry}`)
    this.setState({
        pages: {...this.state.pages, actualPage:nextPage},
        actividades: resp.data.data
    })

  }
  handleToggle = async ({idAct, index}) => {
      const {activiteCountryList} = this.state
      debugger
      var newActiviteCountryList = [...activiteCountryList]
      if(index>=0) {
        newActiviteCountryList.splice(index,1)
      } else {
        newActiviteCountryList.push(idAct)
      }
      try {
          await api.get(`/adminsplaces/toggleCity/${idAct}?idcity=${this.state.city}`)
          this.setState({
            activiteCountryList: newActiviteCountryList
          })
          
      } catch (error) {
          //console.log(error)
      }
  }
  handleSearch = async (e) => {
    e.preventDefault()
    const {country, countryActual} = this.state
    if(country === countryActual) return
    try {
        const resp = await api.get(`/adminsplaces/getfromcountry?country=${country}`)
        this.setState({
            actualcountry: this.state.country,
            actividades: resp.data.data,
            pages:{actualPage: 0, maxPages:resp.data.items}
        })
        
    } catch (error) {
        //console.log(error)
    }
  }
  render() {
    return (
      <>
      <div className="content">
      <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row xs='2'> 
                <Col className="pr-md-1" xs='12' md="4"><CardTitle tag="h4">Añada Actividades dada una distancia</CardTitle></Col>
                
                </Row>
              </CardHeader>
              <CardBody>
              <Form onSubmit={async (e)=>{
                    e.preventDefault()
                      const MySwal = withReactContent(Toast)
                    try{
                    const resp =await api.get(`/ciudades/newActivityForTheCity?id=${this.state.city}&&distance=${this.state.distance}`)
                      if(resp.data.actividadesAgr){

                        await MySwal.fire({
                            title: <p style={{fontSize: '15px'}}> {resp.data.actividadesAgr} Actividades añadidas</p>,
                            icon: 'success',
                            
                        })
                      } else {
                        await MySwal.fire({
                            title: <p style={{fontSize: '15px'}}> Sin actividades para añadir</p>,
                            icon: 'success',
                            
                        })
                      }
                    }catch(error){
                      //console.log(error)
                      
                      await MySwal.fire({
                            title: <p style={{fontSize: '15px'}}>Actividades no añadidas</p>,
                            icon: 'error',
                            
                        })
                    }
                  }}>
                    <Label>distancia en kilometros desde el centro de la ciudad</Label>
                    <Row>
                    <Col className="pr-md-1" xs="8">
                    <Input value={this.state.distance} onChange={(e)=> {
                        this.setState({distance:e.target.value})
                    }} type='number' min={1}></Input></Col>
                    
                    <Col className="p-0" xs="2">
                      <ButtonGroup size='sm'>
                        <Button type='submit' >agregar</Button>
                      </ButtonGroup>
                    </Col>
                    
                    </Row>
                  </Form>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <Row xs='2'> 
                <Col className="pr-md-1" xs='12' md="4"><CardTitle tag="h4">Añada Actividades</CardTitle></Col>
                <Col className="pr-md-1" xs='12' md="4">
                <ButtonGroup>
                  <Button size='sm' onClick={this.PrevPage}>Anterior</Button>
                  <Button size='sm' disabled>{this.state.pages.actualPage+1} de {this.state.pages.maxPages}</Button>
                  <Button size='sm' onClick={this.nextPage}>Siguiente</Button>
                </ButtonGroup>
                </Col>
                <Col className="pr-md-1" xs='12' md="4">
                  <Form onSubmit={this.handleSearch}>
                    <Row>
                    <Col className="pr-md-1" xs="8">
                    <Input value={this.state.country} onChange={(e)=> {
                        this.setState({country:e.target.value})
                    }} type='text'>
                    {/* <option key={`countries`} value=''>{`Todos`}</option> 
                    {countryJSON.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })} */}
                    </Input>
                    </Col>
                    
                    <Col className="p-0" xs="2">
                    <ButtonGroup size='sm'>
                      <Button type='submit' >Buscar</Button>
                    </ButtonGroup>
                    </Col>
                    
                    </Row>
                  </Form>
                </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Nombre</th>
                      <th className="text-center">Lugar</th>
                      <th className="text-center">Estrellas</th>
                      <th className="text-center">Coordenadas</th>
                      <th className="text-center">añadir</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.actividades.map((c, index) => {
                        const include = this.state.activiteCountryList.findIndex((it) => it === c._id)
                        return(
                      <tr key={`actividad-${index}`}>
                        <td>{c.name}</td>
                        <td className="text-center">{c.place}</td>
                        <td className="text-center">{c.stars}</td>
                        <td className="text-center">{`${c.lat}, ${c.lon}`}</td>
                        <td className="text-center">
                        <Button onClick={() => {
                          this.handleToggle({idAct: c._id, index :include})
                        }}  size='sm' type='button' color={include >=0 ? 'danger' : 'primary'}>{include>=0 ? 'Eliminar' : 'Añadir'}</Button>
                        </td>
                      </tr>
                    )})}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(FormAddActToCity);
